import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Stack, Typography } from '@mui/material';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import { brand, radius } from './brand';

const roles = [
    {key: 'issuer', Icon: BadgeOutlinedIcon},
    {key: 'holder', Icon: AccountBalanceWalletOutlinedIcon},
    {key: 'verifier', Icon: VerifiedUserOutlinedIcon},
];

const protocols = ['issuance', 'presentation'];

export const HowItWorks: FC = () => {
    const {t} = useTranslation();

    return (
        <Stack spacing={4}>
            <Box sx={{
                display: 'grid',
                gridTemplateColumns: {xs: '1fr', md: 'repeat(3, 1fr)'},
                gap: '18px',
            }}>
                {roles.map(({key, Icon}) => (
                    <Stack
                        key={key}
                        spacing={1.25}
                        sx={{
                            background: brand.surface,
                            border: `1px solid ${brand.border}`,
                            borderRadius: radius.card,
                            padding: '24px 22px',
                        }}>
                        <Icon sx={{color: brand.blue, fontSize: 26}}/>
                        <Typography sx={{color: brand.navy, fontWeight: 700, fontSize: '1.08rem'}}>
                            {t(`howItWorks.roles.${key}.title`)}
                        </Typography>
                        <Typography sx={{color: brand.text, fontSize: '.94rem', lineHeight: 1.55}}>
                            {t(`howItWorks.roles.${key}.body`)}
                        </Typography>
                    </Stack>
                ))}
            </Box>

            <Box sx={{
                display: 'grid',
                gridTemplateColumns: {xs: '1fr', md: 'repeat(2, 1fr)'},
                gap: '18px',
            }}>
                {protocols.map(key => (
                    <Stack
                        key={key}
                        spacing={1}
                        sx={{
                            background: brand.backgroundAlt,
                            border: `1px solid ${brand.accentSoft}`,
                            borderRadius: radius.card,
                            padding: '22px',
                        }}>
                        <Typography sx={{color: brand.navy, fontWeight: 700, fontSize: '1rem'}}>
                            {t(`howItWorks.protocols.${key}.title`)}
                        </Typography>
                        <Typography sx={{color: brand.text, fontSize: '.94rem', lineHeight: 1.55}}>
                            {t(`howItWorks.protocols.${key}.body`)}
                        </Typography>
                    </Stack>
                ))}
            </Box>

            <Stack
                spacing={1}
                sx={{
                    borderLeft: `3px solid ${brand.green}`,
                    paddingLeft: '20px',
                    maxWidth: '70ch',
                }}>
                <Typography sx={{color: brand.navy, fontWeight: 700, fontSize: '1rem'}}>
                    {t('howItWorks.selectiveDisclosure.title')}
                </Typography>
                <Typography sx={{color: brand.text, fontSize: '.98rem', lineHeight: 1.6}}>
                    {t('howItWorks.selectiveDisclosure.body')}
                </Typography>
            </Stack>
        </Stack>
    );
};
